/**
 * A mode owns the screen, so the sheets give way to it (job #568, Tom
 * 2026-10-24: "listening mode takes me to the library and not to actual
 * listening mode").
 *
 * The Library and Settings are slide-up sheets in PlayerContainer at z-index
 * 2000; Listening's overlay lives in LearningPlayer at 1000, under the bar.
 * The mode tray stays reachable while a sheet is up, and picking Listening
 * there opened the mode UNDER the open Library: the learner saw the Library.
 * The Library's own Listening doors already closed it first; the tray did
 * not. Whenever a mode opens, by whatever door, every sheet closes.
 */
import { watch, type Ref } from 'vue'

export function useSheetsYieldToMode(mode: Ref<string | null>, sheets: Ref<boolean>[]): void {
  watch(mode, (m) => {
    if (!m) return
    for (const s of sheets) s.value = false
  })
}
